import * as types from './types';

const getPostingLeads = (days, startPeriod, endPeriod) => ({
  type: types.FETCH_POSTING_LEADS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/statistic/publisher`,
    method: 'GET',
    query: { days, startPeriod, endPeriod }
  }
});

const getPostingLeadsCharts = (days, startPeriod, endPeriod) => ({
  type: types.FETCH_POSTING_LEADS_CHARTS,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/panel/api/v1/statistic/publisher/daily`,
    method: 'GET',
    query: { days, startPeriod, endPeriod }
  }
});

export { getPostingLeads, getPostingLeadsCharts };
